import { useState } from 'react';

import {
  ImageLightbox,
  ImageLightboxImage,
  ImageLightboxWrapper,
} from 'approot/activity-builder/lightbox/activity-builder-image-lightbox.style';
import { useImageDimensionEffect } from 'approot/shared/images/images.hooks';
import { ResponsiveImage } from 'approot/shared/images/imgix-responsive.constants';
import { getLargestImage } from '../shared/logic/get-largest-image';
import { ComponentImage } from '../component-image';
import ActivitySheet from '../shared/sheet/activity-sheet';

type Props = {
  altText: string;
  imageUrls: ResponsiveImage[];
  onClose: () => void;
};

const RiveLargeStaticPreview = ({ altText, imageUrls, onClose }: Props) => {
  const [isLoading, setIsLoading] = useState<boolean>(true);

  const { imageDimensions, setContainerElement } = useImageDimensionEffect({
    imageUrl: getLargestImage(imageUrls),
    onComplete: () => setIsLoading(false),
  });

  return (
    <ActivitySheet
      isVisible
      title={altText || 'Expanded static image'}
      onClose={onClose}
    >
      <ImageLightbox>
        <ImageLightboxImage $isLoading={isLoading}>
          <ImageLightboxWrapper ref={setContainerElement}>
            {!isLoading && (
              <ComponentImage
                images={imageUrls || []}
                altText={altText}
                imageDimensions={imageDimensions}
              />
            )}
          </ImageLightboxWrapper>
        </ImageLightboxImage>
      </ImageLightbox>
    </ActivitySheet>
  );
};

export default RiveLargeStaticPreview;
